const optimizationPipelineLogEn = {
	optimizationPipelineLogTable: 'Optimization Pipeline Log',
	timestamp: 'Timestamp',
	tag: 'Tag',
	objective: 'Objective',
	state: 'State',
	name: 'Name',
	optimizationPipelineLogEditForm: 'Optimization Pipeline Log',
	basic: 'Basic',
	table_name: 'Table Name',
	description: 'Description',
	fields: 'Fields',
	type: 'Type',
	userGroup: 'User Group'
};

export default optimizationPipelineLogEn;